import { render, staticRenderFns } from "./CreateGroup.vue?vue&type=template&id=34854566&scoped=true"
import script from "./CreateGroup.vue?vue&type=script&lang=ts"
export * from "./CreateGroup.vue?vue&type=script&lang=ts"
import style0 from "./CreateGroup.vue?vue&type=style&index=0&id=34854566&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34854566",
  null
  
)

export default component.exports